import {
  SEARCH_LEAD_BY,
  LS_TYPE_FILTERS,
  PHONE_NUMBER_RADIO,
  FB_CONVERSION_API_OPTS,
  LANDING_PAGE_TEMPLATES,
  TIKTOK_CONVERSION_API_OPTS
} from "../strings";

const metaPixelOptions = [
  FB_CONVERSION_API_OPTS.WAREHOUSES,
  FB_CONVERSION_API_OPTS.GMBHS,
  FB_CONVERSION_API_OPTS.PIXEL_2_WAREHOUSE
];
// TikTok has one global pixel option for Phase 1.
const tiktokPixelOptions = [TIKTOK_CONVERSION_API_OPTS.GLOBAL];
// Cockpit shows one Conversion API dropdown for all Meta and TikTok pixels.
export const conversionApiOptions = [
  ...metaPixelOptions,
  ...tiktokPixelOptions
];

export const leadServiceQuestions = [
  {
    id: "question1",
    name: "Gibt es einen bestimmten Grund, weshalb Sie sich genau jetzt für 'Produkt' interessieren?"
  },
  { id: "question2", name: "Wie groß soll Produkt am Ende werden?" },
  {
    id: "question3",
    name: "Gibt es einen genauen Zeitpunkt, wann das Projekt fertiggestellt sein soll?"
  },
  {
    id: "question4",
    name: "Haben Sie sich bereits zu 'Produkt' informiert und wünschen Sie dahingehend tiefergehende Beratung?"
  },
  {
    id: "question5",
    name: "Was müsste 'Produkt' für Sie am Ende mitbringen, damit alles nach Ihren Vorstellungen gelaufen ist?"
  },
  {
    id: "question6",
    name: "Welche Aspekte an 'Produkt' sind Ihnen besonders wichtig, und warum?"
  },
  {
    id: "question7",
    name: "Was ist Ihnen eher wichtig, das Design, die Funktionalität oder der Preis?"
  },
  {
    id: "question8",
    name: "Haben Sie diesbezüglich bereits mit anderen Anbietern gesprochen, wenn ja, was hat Ihnen gefehlt?"
  },
  {
    id: "question9",
    name: "Gibt es bereits eine Art Inspiration, die Ihnen besonders gut gefällt?"
  },
  {
    id: "question10",
    name: "Gibt es bestimmte Punkte, die Ihnen bei einer eventuellen Montage besonders wichtig sind?"
  },
  {
    id: "question11",
    name: "Welche handwerkliche Erfahrung hast du gesammelt?"
  },
  {
    id: "question12",
    name: "Was hast du beruflich in den letzten 12 Monaten getan?"
  }
];
export const domainList = [
  "dein-terrassendach.de",
  "kaffeevollautomaten-vergleichen.de",
  "deine-traumkueche.de",
  "virtueller-rundgang-360.de",
  "treppenlift-online.com",
  "carport-aktuell.de",
  "dein-traumpool.de",
  "spanndecken-vergleich.de",
  "deine-traumkueche.ch",
  "deine-badsanierung.de",
  "angebote-ums-haus.de",
  "dein-neuerjob.de",
  "deine-sonnenenergie.de",
  "deine-sicherheitstechnik.de",
  "traumkueche-angebot.de",
  // "hörgeräte-himmelsthür.de",
  "dein-traum-wintergarten.de",
  "deine-sanierung.de",
  "deine-sanierung.ch",
  "traum-buero.de",
  "angebote-ums-haus.at",
  "dein-neuerjob.at",
  "deine-klimatechnik.de",
  "deine-traumkueche.at",
  "b2bkonzepte.de",
  "traum-haustuer.de",
  "angebote-ums-haus.ch",
  "dein-neuerjob.ch",
  "regionale-kunden.de",
  "industrie-angebote.de",
  "dein-terrassendach.at"
];

export const designObj = {
  backgroundImage: null,
  companyLogo: null,
  partnerLogo: null,
  partnerLogoDisplay: true,
  // new blank funnels/templates: badge with the company logo (Asana
  // 1213410886347834); loaded funnels and templates keep their own design
  partnerLogoMode: "AUTO_LIGHT",
  baseColor: "#9F285A",
  companyLogoBackground: "#abc123",
  companyLogoBackgroundDisplay: true,
  footerForeground: "#000000",
  companyLogoScale: "100",
  modernBackgroundOne: "#000000",
  modernBackgroundTwo: "#000000",
  modernContrastColor: "#000000",
  modernHeaderLabelsColor: "#000000",
  modernHeadline: "",
  modernFunnelHeadline: "",
  additionalTaglineLabelOne: "",
  additionalTaglineLabelTwo: "",
  additionalTaglineColor: "#ffffff",
  additionalTaglineBackground: "#000000",
  modernHeaderCallLabel: "",
  modernHeaderPhoneNumber: null,
  modernHeaderEmailAddress: "",
  modernNextButtonText: "",
  modernNextButtonTextColor: "#000000",
  modernNextButtonBackground: "#000000",
  modernNextButtonHoverBackground: "#000000",
  modernSubmitButtonText: "",
  modernSubmitButtonTextColor: "#000000",
  modernSubmitButtonBackground: "#000000",
  modernSubmitButtonHoverBackground: "#000000",
  modernFormInfoLabelOne: "",
  modernFormInfoLabelTwo: "",
  modernFormInfoLabelThree: "",
  modernFormHeading: "",
  policyDisplay: false,
  policyCheckboxText: "",
  uspIcons: []
};
export const textElemObj = {
  nextButtonText: "Weiter",
  nextButtonBackground: "#0d6efd",
  waitingScreen: "",
  zipCodeScreen: "",
  waitingScreenTwo: "",
  formScreenHeader: "",
  formScreenSubtext: "",
  formHeadline: "",
  subHeadlineForm: "",
  zipCodeScreenButton: "",
  fieldTitleName: "",
  fieldPlaceholderName: "",
  fieldTitleEmail: "",
  fieldPlaceholderEmail: "",
  fieldTitlePhone: "",
  fieldPlaceholderPhone: "",
  submitButton: "",
  submitButtonSubtext: "",
  submitButtonBackground: "",
  formHeaderBackground: "",
  numberCheck: PHONE_NUMBER_RADIO.STANDARD
};
export const thankYouPageObj = {
  redirectUrl: "",
  websiteButton: "",
  websiteButtonText: "Webseite öffnen",
  thankyouPageHeadline: "",
  thankyouPageText: "",
  greetingPhrase: ""
};

export const INITITIAL_LOADING_DATA = {
  isLoading: false,
  loadingText: ""
};

export const advertisingAccountOptions = [
  { name: "A&M Unternehmerberatung GmbH #1", _id: "act_2214719712102223" }
];

export const countryCodesHash = {
  switzerland: "+41",
  austria: "+43",
  italy: "+39",
  netherlands: "+31",
  luxemburg: "+352",
  poland: "+48",
  spain: "+34",
  croatia: "+385"
};

export const countryFlagEmojiHash = {
  switzerland: "🇨🇭",
  austria: "🇦🇹",
  italy: "🇮🇹",
  netherlands: "🇳🇱",
  luxemburg: "🇱🇺",
  poland: "🇵🇱",
  spain: "🇪🇸",
  croatia: "🇭🇷"
};

export const leadSearchOptions = {
  PHONE: SEARCH_LEAD_BY.PHONE,
  EMAIL: SEARCH_LEAD_BY.EMAIL,
  FUNNEL: SEARCH_LEAD_BY.FUNNEL
};

export const landingPageTemplateOptions = (translator) => [
  {
    name: translator("preLandingPage.templateOneOptLabel"),
    _id: LANDING_PAGE_TEMPLATES.FUNNEL_LANDING_PAGE_TEMP_ONE
  },
  {
    name: translator("preLandingPage.templateTwoOptLabel"),
    _id: LANDING_PAGE_TEMPLATES.FUNNEL_LANDING_PAGE_TEMP_TWO
  }
];

export const iconPickerStyles = {
  containerStyles: {
    width: "300px",
    height: "400px",
    padding: "12px",
    justifyContent: "center",
    border: "1px solid var(--field-border-color-regular)"
  },
  searchInputStyles: {
    width: "100%",
    display: "block",
    fontSize: "16px",
    color: "#212529",
    maxHeight: "35px",
    lineHeight: "1.5",
    fontWeight: "400",
    appearance: "none",
    padding: "6px 12px",
    borderRadius: "6px",
    marginBottom: "10px",
    backgroundColor: "#fff",
    border: "1px solid var(--field-border-color-regular)",
    transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out"
  },
  pickerIconStyles: {
    float: "left",
    width: "50px",
    height: "50px",
    display: "flex",
    fontSize: "22px",
    cursor: "pointer",
    borderRadius: "3px",
    alignItems: "center",
    margin: "0 12px 12px 0",
    justifyContent: "center",
    boxShadow: "0 0 0 1px #ddd"
  },
  buttonStyles: ({ hasError }) => ({
    width: "100%",
    borderRadius: "6px",
    border: `1px solid ${
      hasError ? "red" : "var(--field-border-color-regular)"
    }`
  }),
  buttonIconStyles: {
    display: "flex",
    fontSize: "22px"
  }
};

export const lsTypeFilterOptions = (translator) => [
  { name: translator("lsTypeFilters.all"), id: LS_TYPE_FILTERS.ALL },
  { name: translator("lsTypeFilters.leadService"), id: LS_TYPE_FILTERS.LS },
  {
    name: translator("lsTypeFilters.leadServicePlus"),
    id: LS_TYPE_FILTERS.LS_PLUS
  },
  {
    name: translator("lsTypeFilters.leadServicePlusWithAppointment"),
    id: LS_TYPE_FILTERS.LS_PLUS_WITH_APPOINTMENT
  }
];
